
import { mapGetters } from 'vuex'

export default {
  name: 'AddUserCard',
  emits: ['create', 'close'],
  data: () => ({
    users: [],
    newUserEmail: '',
    newUserRole: 'user',
    roles: [
      { text: 'Nutzer', value: 'user' },
      { text: 'Verwaltung', value: 'editor' },
      { text: 'Admin', value: 'admin' },
    ],
    ruleEmail: (v) =>
      !v ||
      /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
      'E-mail muss gültig sein',

    ruleRequired: (v) => !!v || 'Dieses Feld ist erforderlich',
  }),
  computed: {
    ...mapGetters(['maxTokens']),
  },
  methods: {
    addUser() {
      if (!this.$refs.userInvite.validate()) return
      const user = {
        email: this.newUserEmail,
        id: parseInt(Math.random() * 1000),
        pending: true,
        usedTokens: 0,
        limit: this.maxTokens,
        role: this.newUserRole,
      }
      this.newUserEmail = ''
      this.$emit('create', user)
      this.$emit('close')
    },
  },
}
